<template>
    <div class="container">
        <div class="scroll-container" ref="container">
            <div>
                <div class="scroll-content" ref="content" :style="{ animationDuration: duration + 's' }">
                    <span v-for="msg in messages" :key="msg.id"><strong>{{ msg.title }}:</strong> {{ msg.message }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick, watch, onBeforeUnmount } from 'vue'
import apiClient          from '@/api'

const messages     = ref([])
const container    = ref(null)
const content      = ref(null)
const duration     = ref(40)
let resizeObserver = null
let intervalId     = null
const SPEED        = 240

const fetchMessages = async () => {
    try {
        const response = await apiClient.get('fetch_messages/')
        if (response.data.data.length == 0) {
            messages.value = [{id: 0, title: 'Bienvenue chez BGE ADIL', message: 'Ici, vos idées prennent forme.'}]
        } else {
            messages.value = response.data.data
            console.log(response.data.message, response.data.data)
        }
    } catch (error) {
        console.error('Error fetching messages:', error)
    }
}

let lastContentWidth = 0

const calculateDuration = async () => {
    await nextTick()
    if (!container.value || !content.value) return

    const containerWidth = container.value.offsetWidth
    const contentWidth = content.value.scrollWidth

    if (contentWidth === lastContentWidth) return
    lastContentWidth = contentWidth

    const distance = containerWidth + contentWidth
    duration.value = distance / SPEED

    content.value.style.setProperty('--start', `${containerWidth}px`)
    content.value.style.setProperty('--end', `-${contentWidth}px`)

    content.value.style.animation = 'none'
    content.value.offsetHeight
    content.value.style.animation = ''
}

watch(messages, (newVal, oldVal) => {
    if (newVal.length != oldVal.length) calculateDuration()
})

onMounted(async () => {
    await fetchMessages()
    
    watch(messages, calculateDuration)

    resizeObserver = new ResizeObserver(() => {
        calculateDuration()
    })

    if (container.value) resizeObserver.observe(container.value)
    if (content.value)   resizeObserver.observe(content.value)

    // Temporary fix check for new messages every 10 minutes
    intervalId = setInterval(async () => {
        await fetchMessages()
    }, 1 * 60 * 1000)
})

onBeforeUnmount(() => {
    if (resizeObserver) resizeObserver.disconnect()
})
</script>

<style lang="scss" scoped>
.container {
    padding: 1rem;
    background-color: #fff;
    border-radius: 25px;
    overflow: hidden;

    height: fit-content;
}

.scroll-container {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}

.scroll-content {
    display: inline-block;
    white-space: nowrap;
    animation-name: scroll-left;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    font-size: 2vw;
}

.scroll-content span {
    display: inline-block;
}

@keyframes scroll-left {
    0% {
        transform: translateX(var(--start));
    }

    100% {
        transform: translateX(var(--end));
    }
}
</style>
